<template>
    <div class="flex items-center justify-between gap-3 mb-4">
        <div class="min-w-0">
            <h2 class="text-[15px] font-semibold tracking-[-0.01em] text-ink truncate">{{ text }}</h2>
            <p v-if="subtitle" class="text-[12px] text-muted mt-0.5">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.default" class="shrink-0">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeadingComp',
    props: {
        text: { type: String, default: '' },
        subtitle: { type: String, default: '' },
    },
}
</script>
